/**
 * Test IDs for QA automation.
 */
export const testIds = {
  reportGeneratorReportType: "report-generator-report-type",
  reportGeneratorReportTypeOption: "report-generator-report-type-option",
  reportGeneratorDriverPicker: "report-generator-driver-picker",
  reportGeneratorDriverSearch: "report-generator-driver-search",
  reportGeneratorGenerateAndDownloadPdf: "report-generator-generate-and-download-pdf",
  reportGeneratorDownloadCsv: "report-generator-download-csv",
  reportGeneratorSendByEmail: "report-generator-send-by-email",
  reportGeneratorEmail: "report-generator-email",
  reportGeneratorSend: "report-generator-send",
} as const;
